let loading = null

export default function loadV2Selection() {
  loading ??= import('@/views/V2Selection.vue').catch((error) => {
    loading = null
    throw error
  })
  return loading
}
